var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-xl-5 col-sm-5 col-xs-12"},[_c('b',{staticClass:"subsection-100"},[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"col-xl-7 col-sm-7 col-xs-12"},[_c('div',[_vm._v(" "+_vm._s(_vm.value)+" ")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }